import type {PropertiesPageTabName} from '@github-ui/custom-properties-types'
import {human} from '@github-ui/formatters'
import {Link, useLocation} from '@github-ui/react-router'
import {UnderlineNav} from '@primer/react'
import {useState} from 'react'

interface Props {
  initialActiveTab: PropertiesPageTabName
  definitionsCount: number
  className?: string
}

export function PropertiesPageTabs({definitionsCount, initialActiveTab, className}: Props) {
  const [selectedTab, setSelectedTab] = useState(initialActiveTab)
  const location = useLocation()

  function hrefBuilder(tab: string): string {
    const newParams = new URLSearchParams()
    newParams.set('tab', tab)

    return `${location.pathname}?${newParams.toString()}`
  }

  return (
    <UnderlineNav aria-label="Page selector" className={className} variant="flush">
      <UnderlineNav.Item
        key="properties-list-tab"
        as={Link}
        to={hrefBuilder('properties')}
        {...(selectedTab === 'properties' && {'aria-current': true})}
        onSelect={() => setSelectedTab('properties')}
        counter={human(definitionsCount)}
      >
        <span>Properties</span>
      </UnderlineNav.Item>
      <UnderlineNav.Item
        key="set-values-tab"
        as={Link}
        to={hrefBuilder('set-values')}
        {...(selectedTab === 'set-values' && {'aria-current': true})}
        onSelect={() => setSelectedTab('set-values')}
      >
        <span>Set values</span>
      </UnderlineNav.Item>
    </UnderlineNav>
  )
}
